import React from 'react';
import { HeroVariant60 } from '../components/HeroVariant60';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage60() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1726">
      <Navigation data-id="element-1727" />
      <main data-id="element-1728">
        <HeroVariant60 data-id="element-1729" />
        <WhyUs data-id="element-1730" />
        <Services data-id="element-1731" />
        <FAQ data-id="element-1732" />
        <Testimonials data-id="element-1733" />
        <Consultation data-id="element-1734" />
      </main>
      <Footer data-id="element-1735" />
      <CookieBanner data-id="element-1736" />
      <FloatingContact data-id="element-1737" />
    </div>;
}